
export const requestStripeOnboardingAccout = async (welletContext, jwt) => {
  try {
    return await welletContext.apis.tickets.get(`web/email/requestStripeOnboarding`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
  } catch (e) {
    console.error(e);
    throw e;
  }
};